import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../../services/user/user.service';
import { User } from '../../../../services/user/user';
import { LoadingService } from '../../../../services/loading/loading.service';

@Component({
    selector: 'app-shipper-information',
    templateUrl: './shipper-information.component.html',
    styleUrls: ['./shipper-information.component.css'],
    standalone: false
})
export class ShipperInformationComponent implements OnInit {
  currentUser: User | any;
  private tmssloader;
  constructor(private userService: UserService, private loader: LoadingService) {
    this.tmssloader = loader;
   }

  ngOnInit() {
    this.userService.getCurrentUserObservable().subscribe(currentUser => {
      this.tmssloader.show();
      this.currentUser = currentUser;
      this.tmssloader.hide();
  }, (error) => {
      this.tmssloader.hide();
  });
  }

}
